// Global antd 3 theme + app form styles (compiled with the theme modifyVars).
import 'APP_ROOT/styles/index.less';
// Standalone-viewer chrome (header bar, page surface).
import './styles.css';

import React from 'react';
import ReactDOM from 'react-dom';

import { i18nextConfig } from 'APP_ROOT/i18next';
import App from './App';

i18nextConfig();

ReactDOM.render(React.createElement(App), document.getElementById('root'));
